import { googleMapsScriptUrl } from '@/constants/googleMaps';

let loadPromise: Promise<typeof google> | null = null;

function waitForGoogleMaps(): Promise<typeof google> {
  return new Promise((resolve, reject) => {
    const started = Date.now();
    const timer = window.setInterval(() => {
      if (window.google?.maps?.places) {
        window.clearInterval(timer);
        resolve(window.google);
        return;
      }
      if (Date.now() - started > 15000) {
        window.clearInterval(timer);
        reject(new Error('Google Maps failed to load.'));
      }
    }, 50);
  });
}

/** Load Maps JavaScript API (Places) once per session. Region only applies on first load. */
export function loadGoogleMaps(region?: string): Promise<typeof google> {
  if (window.google?.maps?.places) {
    return Promise.resolve(window.google);
  }

  if (!loadPromise) {
    loadPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector<HTMLScriptElement>(
        `script[src^="https://maps.googleapis.com/maps/api/js"]`,
      );
      if (existing) {
        waitForGoogleMaps().then(resolve).catch(reject);
        return;
      }

      const script = document.createElement('script');
      script.src = googleMapsScriptUrl(region);
      script.async = true;
      script.defer = true;
      script.onerror = () => {
        loadPromise = null;
        reject(new Error('Failed to load Google Maps script.'));
      };
      script.onload = () => {
        waitForGoogleMaps().then(resolve).catch(reject);
      };
      document.head.appendChild(script);
    });
  }

  return loadPromise;
}
